module.exports = __webpack_public_path__ + "static/media/1.a6648266.png";